import clsx from 'clsx';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomHtmlHead from 'components/PageLayout/CustomHtmlHead';
import FooterContent from 'components/PageLayout/Footer/FooterContent/FooterContent';
import ProgressBar from 'components/common/ProgressBar';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { useAppSelector } from 'hooks/reduxHooks';
import { CuroLogo } from 'static/images';

import styles from './CuroMainLayout.module.scss';

export interface ICuroMainLayoutProps {
  applicationsBrowserTitle?: string;
  contentClassName?: string;
  innerContentClassName?: string;
  borrowerDetails?: React.ReactElement | React.ReactNode;
}

const CuroHeader = ({
  borrowerDetails,
}: {
  borrowerDetails?: React.ReactElement | React.ReactNode;
}) => {
  const navigate = useNavigate();
  const { logoId } = useAppSelector((state) => state.settings.branding);
  const { progress } = useAppSelector((state) => state.settings);

  return (
    <div className={clsx(styles.headerContainer, styles.containerShadow)}>
      <div className={styles.headerContent}>
        {logoId ? (
          <img
            src={`/api/branding/logo/${logoId}`}
            alt="Curo Logo"
            onClick={() => navigate(CuroAppRoute.Home)}
          />
        ) : (
          <CuroLogo />
        )}
        {borrowerDetails}
      </div>
      {progress && <ProgressBar progress={progress} total={4} />}
    </div>
  );
};

const CuroMainLayout: FC<ICuroMainLayoutProps> = ({
  applicationsBrowserTitle,
  children,
  contentClassName,
  innerContentClassName,
  borrowerDetails,
}) => {
  return (
    <>
      <CustomHtmlHead applicationsBrowserTitle={applicationsBrowserTitle} />
      <div className={clsx(styles.mainLayoutContent, contentClassName)}>
        <CuroHeader borrowerDetails={borrowerDetails} />

        <div className={clsx(styles.innerContent, innerContentClassName)}>{children}</div>

        <div className={styles.footerContainer}>
          <FooterContent
            companyName="Heights Finance. All Rights Reserved."
            currentYear={new Date().getFullYear()}
          />
        </div>
      </div>
    </>
  );
};

export default CuroMainLayout;
